import { Gift } from "lucide-react";

export function GiftFields({ gift, setGift }) {
  const cls = "mt-2 w-full border border-[#e5e5e5] bg-white px-4 py-3 outline-none focus:border-[#0a192f]";
  return (
    <div className="mt-6" data-testid="gift-fields">
      <label className="inline-flex items-center gap-3 cursor-pointer">
        <input data-testid="gift-toggle" type="checkbox" checked={gift.enabled} onChange={(e) => setGift({ ...gift, enabled: e.target.checked })} className="accent-[#0a192f]" />
        <span className="text-sm font-semibold text-[#0a192f] inline-flex items-center gap-2"><Gift className="w-4 h-4 text-[#d4af37]" /> Send this as a gift</span>
      </label>
      {gift.enabled && (
        <div className="mt-4 border-l-2 border-[#d4af37] pl-5 space-y-4" data-testid="gift-form">
          <div>
            <label className="overline text-[#4a4a4a]">Recipient's email</label>
            <input data-testid="gift-email" type="email" required value={gift.to} onChange={(e) => setGift({ ...gift, to: e.target.value })} placeholder="friend@email.com" className={cls} />
          </div>
          <div>
            <label className="overline text-[#4a4a4a]">Your name (as the giver)</label>
            <input data-testid="gift-from" maxLength={60} value={gift.from} onChange={(e) => setGift({ ...gift, from: e.target.value })} placeholder="Leia" className={cls} />
          </div>
          <div>
            <label className="overline text-[#4a4a4a]">A note for them (optional)</label>
            <textarea data-testid="gift-note" rows={3} maxLength={400} value={gift.note} onChange={(e) => setGift({ ...gift, note: e.target.value })} placeholder="Thought of you when I read this…" className={cls} />
            <div className="text-xs text-[#4a4a4a] mt-1 text-right">{gift.note.length}/400</div>
          </div>
          <p className="text-xs text-[#4a4a4a]">They'll receive the download link and your note by email the moment payment completes. You'll get a receipt too.</p>
        </div>
      )}
    </div>
  );
}

export const EMPTY_GIFT = { enabled: false, to: "", from: "", note: "" };
export const giftPayload = (gift) => (gift.enabled ? { gift_to_email: gift.to, gift_from_name: gift.from, gift_note: gift.note } : {});
